import { render } from "./ReconfigureConvertorForm.vue?vue&type=template&id=12f9db47"
import script from "./ReconfigureConvertorForm.vue?vue&type=script&lang=js"
export * from "./ReconfigureConvertorForm.vue?vue&type=script&lang=js"
script.render = render

export default script